// src/components/NotificationPortalModal/NotificationPortalContainer.tsx

import React from "react";
import { useLocation } from "react-router-dom";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Typography,
  Button,
} from "@mui/material";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";

import { INotification } from "@modules/notifications/model/INotifications";
import { useFlags } from "flagsmith/react";
import { NOTIFICATION_FLAG } from "@utils/featureFlags";

interface Props {
  open: boolean;
  notification: INotification | null;
  hasNext: boolean;
  onClose: () => void;
  onNext: () => void;
}

const NotificationPortalModal: React.FC<Props> = ({
  open,
  notification,
  hasNext,
  onClose,
  onNext,
}) => {
  const flag = useFlags([NOTIFICATION_FLAG]);
  const { pathname = "" } = useLocation();
  const isSidebarAdmin = pathname.includes("/admin");
  if (
    !notification ||
    isSidebarAdmin ||
    !flag.admin_sidebar_notification.enabled
  )
    return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          p: 2,
        },
      }}
    >
      {/* HEADER COM ID NO CANTO SUPERIOR DIREITO */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          px: 1,
          pt: 1,
        }}
      >
        <Box />
        <Typography sx={{ fontSize: 12, color: "#888" }}>
          #{notification.id}
        </Typography>
      </Box>

      {/* ÍCONE CENTRAL */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          mt: 1,
        }}
      >
        <Box
          sx={{
            width: 60,
            height: 60,
            bgcolor: "#FFF2F2",
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <NotificationsActiveIcon sx={{ fontSize: 32, color: "#E53935" }} />
        </Box>
      </Box>

      {/* TÍTULO */}
      <DialogTitle
        sx={{
          textAlign: "center",
          fontSize: 22,
          fontWeight: 700,
          color: "#222",
        }}
      >
        {notification.title}
      </DialogTitle>

      {/* TEXTO */}
      <DialogContent>
        <Typography
          sx={{
            textAlign: "center",
            color: "#444",
            fontSize: 15,
            lineHeight: 1.6,
            mb: 3,
          }}
        >
          {notification.message}
        </Typography>

        {/* IMAGEM */}
        {notification.imageUrl && (
          <Box sx={{ textAlign: "center", mt: 1 }}>
            <img
              src={notification.imageUrl}
              alt="Imagem da notificação"
              style={{
                maxWidth: "100%",
                borderRadius: 8,
              }}
            />
          </Box>
        )}
      </DialogContent>

      {/* BOTÕES */}
      <DialogActions
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: 2,
          mb: 2,
        }}
      >
        <Button
          onClick={onClose}
          sx={{
            color: "#E53935",
            fontWeight: 600,
            textTransform: "none",
          }}
        >
          Fechar
        </Button>
        {/* BOTÃO PRINCIPAL (VERMELHO) */}
        <Button
          variant="contained"
          onClick={onNext}
          sx={{
            bgcolor: "#E53935",
            color: "#FFF",
            fontWeight: 600,
            px: 4,
            "&:hover": { bgcolor: "#C62828" },
          }}
        >
          {hasNext ? "Próxima" : "Marcar como lida"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NotificationPortalModal;
